import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import moment from "moment";
import { useEffect } from "react";
import DateField from "../common/date.field";
import { useForm } from "../common/form.util";

export default function TermForm(props) {
	const formCtx = useForm(props.term, props);
	let term = formCtx?.data;

	useEffect(() => {
		formCtx.setData(props.term);
	}, [props.term]);

	let startDate = term?.startDate ? moment(term.startDate) : null;
	let endDate = term?.endDate ? moment(term.endDate) : null;

	return (
		<Stack direction="column" sx={props.sx}>
			<TextField label="Name" variant="standard" value={term?.name || ''} onChange={(e) => formCtx.onChange(e, 'name')} required autoFocus />
			<DateField label="Start Date" variant="standard" value={startDate} onChange={(e) => formCtx.onChange(e, 'startDate')} views={['year', 'month', 'day']} openTo="month" required />
			<DateField label="End Date" variant="standard" value={endDate} onChange={(e) => formCtx.onChange(e, 'endDate')} views={['year', 'month', 'day']} openTo="month" required />
		</Stack>
	);
}